import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const openTimeSlotFn = /* @__PURE__ */ createRecipe('openTimeSlot', {
  "selected": false
}, [])

const openTimeSlotVariantMap = {
  "selected": [
    "true"
  ]
}

const openTimeSlotVariantKeys = Object.keys(openTimeSlotVariantMap)

export const openTimeSlot = /* @__PURE__ */ Object.assign(memo(openTimeSlotFn.recipeFn), {
  __recipe__: true,
  __name__: 'openTimeSlot',
  __getCompoundVariantCss__: openTimeSlotFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: openTimeSlotVariantKeys,
  variantMap: openTimeSlotVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, openTimeSlotVariantKeys)
  },
  getVariantProps: openTimeSlotFn.getVariantProps,
})